import React from 'react';
import Layout from '../components/Layout';

const TMSPricing = () => {
  return (
    <Layout>
      <section id="greenorange-dest">
        <section className="banner">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <h1 className="mar0">TMS Pricing & Signup</h1>
                <p className="colorWht">Our best plans to fit any company, any budget for fleet operators everyday.</p>
              </div>
            </div>
          </div>
        </section>
        <div className="clearfix"></div>
        <section className="content-dest1">
          <div className="container">
            <div className="row tms-pricing">
              <article className="">
                <h2 className="plan-type text-center">
                  <strong>Free</strong>
                  10 Bookings
                </h2>
                <div className="priceContent">
                  <div className="priceAmt">
                    <span>$</span> <span>0</span> / month
                  </div>
                  <ul>
                    <li>Users - 3</li>
                    <li>Bookings - 10</li>
                    <li>Modules - Limited</li>
                    <li className="circle-cross">Database</li>
                    <li className="circle-cross">Report Generator</li>
                    <li className="circle-cross">Document Management</li>
                    <li>Free Contact Form</li>
                    <li>App - 200$ Additional</li>
                  </ul>
                  <br />
                  <p className="Btnsignup">
                    <a className="btn btn-lg btn-primary signupBtn" title="Free Signup" href="/tms-signup" role="button">
                      Sign Up!
                    </a>
                  </p>
                </div>
              </article>
              <article className="">
                <h2 className="plan-type text-center">
                  <strong>Basic</strong>
                  75 Bookings
                </h2>
                <div className="priceContent">
                  <div className="priceAmt">
                    <span>$</span> <span>250</span> / month
                  </div>
                  <ul>
                    <li>Users - 5</li>
                    <li>Bookings - 75</li>
                    <li>Modules - Limited</li>
                    <li className="circle-cross">Database</li>
                    <li className="circle-cross">Report Generator</li>
                    <li className="circle-cross">Document Management</li>
                    <li>Support - Upto 25 Bookings</li>
                    <li>Free Contact Form</li>
                    <li>App - 200$ Additional</li>
                  </ul>
                  <p className="Btnsignup">
                    <a className="btn btn-lg btn-primary signupBtn" title="Free Signup" href="/tms-signup" role="button">
                      Sign Up!
                    </a>
                  </p>
                </div>
              </article>
              <article className="">
                <h2 className="plan-type text-center">
                  <span className="offer">Early Bird Offer</span>
                  <strong>Rookie</strong>
                  250 Bookings
                </h2>
                <div className="priceContent">
                  <div className="priceAmt">
                    <strike>600</strike>
                    <span>$</span> <span>360</span> / month
                  </div>
                  <ul>
                    <li>Users - 10</li>
                    <li>Bookings - 250</li>
                    <li>Modules - Limited</li>
                    <li className="circle-cross">Database</li>
                    <li className="circle-cross">Report Generator</li>
                    <li className="circle-cross">Document Management</li>
                    <li>Support - Upto 25 Bookings</li>
                    <li>Free Contact Form</li>
                    <li>App - 200$ Additional</li>
                  </ul>
                  <p className="Btnsignup">
                    <a className="btn btn-lg btn-primary signupBtn" title="Free Signup" href="/tms-signup" role="button">
                      Sign Up!
                    </a>
                  </p>
                </div>
              </article>
              <article className="">
                <h2 className="plan-type text-center">
                  <span className="offer">Early Bird Offer</span>
                  <strong>Professional</strong>
                  Unlimited
                </h2>
                <div className="priceContent">
                  <div className="priceAmt">
                    <strike>800</strike>
                    <span>$</span> <span>480</span> / month
                  </div>
                  <ul>
                    <li>Users</li>
                    <li>Bookings</li>
                    <li>Modules</li>
                    <li>Database</li>
                    <li>Report Generator</li>
                    <li>Document Management</li>
                    <li>Support</li>
                    <li>Free Contact Form</li>
                    <li>App - 200$ Additional</li>
                  </ul>
                  <p className="Btnsignup">
                    <a className="btn btn-lg btn-primary signupBtn" title="Free Signup" href="/tms-signup" role="button">
                      Sign Up!
                    </a>
                  </p>
                </div>
              </article>
              <article className="">
                <h2 className="plan-type text-center">
                  <span className="offer">Early Bird Offer</span>
                  <strong>Enterprise Edition</strong>
                  Unlimited
                </h2>
                <div className="priceContent">
                  <div className="priceAmt">
                    <strike>1000</strike> <span>$</span> <span>600</span> / month
                  </div>
                  <ul>
                    <li>Users</li>
                    <li>Bookings</li>
                    <li>Modules</li>
                    <li>Database</li>
                    <li>Report Generator</li>
                    <li>Document Management</li>
                    <li>Support</li>
                    <li>Free Mail Server</li>
                    <li>Free Website Upgrade</li>
                    <li>Free Installation</li>
                    <li>Free Module Upgrade</li>
                    <li>Free Contact Form</li>
                    <li className="marB0">App - 200$ Additional</li>
                  </ul>
                  <p className="Btnsignup">
                    <a className="btn btn-lg btn-primary signupBtn" title="Free Signup" href="/tms-signup" role="button">
                      Sign Up!
                    </a>
                  </p>
                </div>
              </article>
            </div>
          </div>
        </section>
      </section>
    </Layout>
  );
};

export default TMSPricing;

